import React from "react";

const PanchangPreviewTable = ({ data }) => {
  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Country</th>
            <th>Location</th>
            <th>Gregorian Date</th>
            <th>Date Label</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>

              <td className="text-nowrap">
                {row?.country?.english}
                <br />
                {row?.country?.gujarati}
                <br />
                {row?.country?.hindi}
              </td>
              <td className="text-nowrap">
                {row?.location?.english}
                <br />
                {row?.location?.gujarati}
                <br />
                {row?.location?.hindi}
              </td>
              <td className="text-nowrap">{row?.gregorianDate}</td>

              <td className="text-nowrap">
                {row?.date?.english}
                <br />
                {row?.date?.gujarati}
                <br />
                {row?.date?.hindi}
              </td>
              
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PanchangPreviewTable;
